import selectPlaceholder from "./select-placeholder";

const createLabel = () => {
	$( '.gform_wrapper .gfield input[aria-required="true"], .gform_wrapper .gfield select[aria-required="true"]' ).each( function() {
		const field        = $( this );
		const parent_field = field.closest( '.ginput_container' );
		const label        = field.closest( '.gfield' ).find( '.gfield_label' );

		label.detach().appendTo( parent_field );
	} );
}

export const initFormEvents = () => {
    // on init
	createLabel();
	
    // after wrong validation
	$( document ).on( "gform_post_render", function () {
		selectPlaceholder();
		createLabel();
	});
}


// WEBPACK FOOTER //
// ./scripts/modules/forms.js